import { render, staticRenderFns } from "./InsectHistory.vue?vue&type=template&id=8929c980&scoped=true&"
import script from "./InsectHistory.vue?vue&type=script&lang=ts&"
export * from "./InsectHistory.vue?vue&type=script&lang=ts&"
import style0 from "./InsectHistory.vue?vue&type=style&index=0&id=8929c980&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8929c980",
  null
  
)

export default component.exports